import angular from 'angular'
import moment from 'moment-timezone'

angular
  .module('admin.mini_game_configurations.edit', [])
  .controller('MiniGameConfigurationsEditCtrl', MiniGameConfigurationsEditCtrl)

/** @ngInject */
function MiniGameConfigurationsEditCtrl(
  $scope,
  $rootScope,
  $state,
  $q,
  $timeout,
  $stateParams,
  MiniGameConfigurationsService,
) {
  var vm = this
  vm.model = {}
  vm.coinProducts = []
  vm.channels = []
  vm.sets = []
  vm.bundles = []
  vm.pathImgH = ''
  vm.id = $stateParams.id
  vm.isOpen = false
  vm.isOpen2 = false

  var isDate = function (date) {
    return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
  }

  vm.games = [
    { id: 1, name: 'Storyboard Fight' },
    { id: 2, name: 'Penalty Shootout' },
  ]

  vm.openCalendar = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen = true
  }

  vm.openCalendar2 = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen2 = true
  }

  if (vm.id !== '0') {
    MiniGameConfigurationsService.get($stateParams.id).then(function (result) {
      vm.model = result.results
      if (vm.model['ts-start'] !== undefined && vm.model['ts-start'] !== 0) {
        vm.model['ts-start'] = vm.model['ts-start']
          .toString()
          .substring(0, vm.model['ts-start'].toString().length - 3)
        vm.model['ts-start'] = new Date(parseInt(vm.model['ts-start']))
        vm.data1 = angular.copy(vm.model['ts-start'])
      }
      if (vm.model['ts-end'] !== undefined && vm.model['ts-end'] !== 0) {
        vm.model['ts-end'] = vm.model['ts-end']
          .toString()
          .substring(0, vm.model['ts-end'].toString().length - 3)
        vm.model['ts-end'] = new Date(parseInt(vm.model['ts-end']))
        vm.data2 = angular.copy(vm.model['ts-end'])
      }
    })
  } else {
    vm.model.img = ''
  }

  vm.save = function () {
    var model = angular.copy(vm.model)
    var isUpdate = model.id !== undefined && model.id !== '' && model.id !== 0
    delete model.ts

    if (vm.data1 !== undefined && vm.data1 !== '' && vm.data1 !== null) {
      if (isDate(vm.data1)) {
        var date = parseInt(new Date(new Date(vm.data1).setSeconds(0)).getTime() * 1000)
        model['ts-start'] = date
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    } else {
      model['ts-startstart'] = null
    }

    if (vm.data2 !== undefined && vm.data2 !== '' && vm.data2 !== null) {
      if (isDate(vm.data2)) {
        var date = parseInt(new Date(new Date(vm.data2).setSeconds(0)).getTime() * 1000)
        model['ts-end'] = date
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    } else {
      model['ts-end'] = null
    }

    if (isUpdate) {
      MiniGameConfigurationsService.update(model.id, model).then(function (result) {
        $state.go('admin.mini_game_configurations')
      })
    } else {
      MiniGameConfigurationsService.save(model).then(function (result) {
        $state.go('admin.mini_game_configurations')
      })
    }
  }

  vm.cancel = function () {
    $state.go('admin.mini_game_configurations')
  }

  var watch2 = $scope.$watch('vm.data1', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal) {
      vm.timezoneDate1NY = moment(newVal).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate1LA = moment(newVal).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm A')
    }
  })

  var watch3 = $scope.$watch('vm.data2', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal) {
      vm.timezoneDate2NY = moment(newVal).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate2LA = moment(newVal).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm A')
    }
  })

  $scope.$on('$destroy', function () {
    watch2()
    watch3()
  })
}
